import { memo } from 'react'
import { hp } from 'styles/Sizes'
import Typography from 'components/common/Typography'
import Separator from 'components/common/Separator'
import DefaultBtn from 'components/common/buttons/Default'
import { useTranslation } from 'services/Translation'
import { textPrimary, error } from 'styles/Colors'
import { CS_m } from 'back-end-api'

const texts = (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    title: getText('Reconnect to Call', 'Patient_Details_Actions'),
    message: getText('You have an active AV call in progress. Would you like to rejoin?', 'Patient_Details_Actions'),
    resumeBtnLabel: getText('Resume Call', 'Patient_Details_Actions'),
    endBtnLabel: getText('End Call', 'Patient_Details_Actions'),
  }[key])

interface ResumeAVCallProps {
  appointment: CS_m.ModelsAppointment
  onResume: () => void
  onDismiss: () => void
}

const ResumeAVCall = ({ appointment, onResume, onDismiss }: ResumeAVCallProps) => {
  const { t } = useTranslation(texts)

  const patient = appointment?.summary?.registration
  const complaint = appointment?.summary?.complaint?.name

  return (
    <div>
      <Typography
        type="title"
        className="font-csc65 py-3 mb-3"
        center
        text={t('title')}
        color={textPrimary}
        size={18}
        style={undefined}
      />
      <Typography
        className="mt-3 font-csc45"
        center
        text={t('message')}
        color={textPrimary}
        size={24}
        style={undefined}
      />
      <Typography
        className="mt-3 font-csc45"
        center
        text={`Patient: ${patient?.first_name} ${patient?.last_name}`}
        color={textPrimary}
        size={15}
        style={undefined}
      />
      {complaint && (
        <Typography
          className="mt-3 font-csc45"
          center
          text={`Complaint: ${complaint}`}
          color={textPrimary}
          size={15}
          style={undefined}
        />
      )}
      <Separator size={hp(5)} innerRef={undefined} />
      <div className="flex justify-center items-center">
        <DefaultBtn
          label={t('resumeBtnLabel')}
          onClick={onResume}
          type="submit"
          className="font-csc65"
          reversedColors
          size="12px"
          style={{ width: '10rem', marginRight: '1rem' }}
          color={textPrimary}
          nextIcon={undefined}
        />
        <DefaultBtn
          label={t('endBtnLabel')}
          onClick={onDismiss}
          type="submit"
          className="font-csc65"
          reversedColors
          size="12px"
          style={{ width: '10rem' }}
          color={error}
          nextIcon={undefined}
        />
      </div>
    </div>
  )
}

ResumeAVCall.whyDidYouRender = true

export default memo(ResumeAVCall)
